import steps from "state/steps";

const previousSteps = steps.reduce((result, step, index) => {
  const previousStep = steps[index - 1];

  if (steps) {
    result[step] = previousStep;
  }

  return result;
}, {});

const getPreviousStep = currentStep => previousSteps[currentStep];

export default getPreviousStep;



// WEBPACK FOOTER //
// ./src/state/getPreviousStep.js